import type { GetCourseReviewsSort } from './getCourseReviewsSort';

export type GetCourseReviewsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지당 항목 수
 */
size?: number;
/**
 * 정렬 기준 (최신순, 높은평점순, 낮은평점순, 도움됨순)
 */
sort?: GetCourseReviewsSort;
};
